module.exports = __webpack_public_path__ + "img/ico_new_2.7977cf18.svg";